export default {
    ADD_UTILITY_FUNCTIONS: 'ADD_UTILITY_FUNCTIONS',
    EDIT_UTILITY_FUNCTIONS: 'EDIT_UTILITY_FUNCTIONS',
    DELETE_UTILITY_FUNCTIONS: 'DELETE_UTILITY_FUNCTIONS',
    UPDATE_UTILITY_FUNCTIONS: 'UPDATE_UTILITY_FUNCTIONS',
    RESET_UTILITY_FUNCTIONS: 'RESET_UTILITY_FUNCTIONS'
};